import Category from "@/components/category";
import LinkedContent from "@/components/linked-content";
import TeaserByLineImage from "@/components/teaser-byline-image";
import TeaserDownpull from "@/components/teaser-downpull";
import TeaserHeading from "@/components/teaser-heading";
import Vinjett from "@/components/vinjett";
import { Content } from "@/services/content/types";
import { createImageSizes, createImageUrl } from "@/utils/image";
import classNames from "classnames";
import Image from "next/image";
import Link from "next/link";

type HorizontalProps = {
  article: Content.Article;
  showLinkedContent?: boolean;
};

const Horizontal = (props: HorizontalProps) => {
  const hasLinkedContent = Boolean(props.article.fields.linkedContent?.length);
  const category = props.article.fields.categories?.[0];
  const image =
    props.article.fields.teaserImage || props.article.fields.images?.[0];
  const title = props.article.fields.teaserTitle || props.article.fields.title;
  const author = props.article.fields.authors?.[0];
  const highlighted = props?.article?.fields?.highlighted_v2;
  const parentCategory = category?.fields.parentCategory;
  const color = category?.fields.color || parentCategory?.fields.color;
  const showByline =
    props.article.fields.showByline !== undefined
      ? props.article.fields.showByline
      : false;
  const bylineImage =
    props.article.fields.hideBylineImage !== undefined
      ? props.article.fields.hideBylineImage
      : false;
  const vinjett = props.article.fields.vinjett;
  const teaserLayoutType = props.article.fields.teaserLayoutType;

  return (
    <>
      <LinkedContent
        linkedContent={props.article.fields.linkedContent}
        color={color}
        highlighted={highlighted}
        showLinkedContent={props.showLinkedContent}
        compactMode={true}
        teaserLayoutType={teaserLayoutType}
      >
        <Link href={`/${props.article.fields.slug}`} className="relative">
          <div
            className={classNames(
              "group flex gap-4 justify-between",
              bylineImage ? "border-b border-sand-700 pb-4" : "",
            )}
          >
            {image?.fields.file?.url && (
              <div className="relative w-[350px] h-auto">
                <div className="aspect-w-16 aspect-h-9">
                  <Image
                    fill
                    src={createImageUrl(image.fields.file.url, {
                      crop: "16:9",
                    })}
                    alt={image.fields.alt || ""}
                    className="object-cover "
                    sizes={createImageSizes({
                      mobile: "100vw",
                      tablet: "50vw",
                      desktop: "33vw",
                    })}
                  />
                </div>
              </div>
            )}
            <div className={classNames(bylineImage ? "" : "")}>
              {vinjett && <Vinjett content={vinjett} size="small" />}
              {category && <Category category={category} />}

              {title && (
                <TeaserHeading
                  text={title}
                  className={classNames(
                    "text-2xl md:text-2xl font-semibold",
                    bylineImage ? "max-w-none" : "",
                  )}
                />
              )}

              {bylineImage && author?.fields.image?.fields?.file?.url && (
                <div className="absolute w-[90px] h-[90px] flex-shrink-0 right-0 bottom-0">
                  <TeaserByLineImage
                    showbyLineImage={bylineImage}
                    fileUrl={author.fields.image.fields.file.url}
                    altText={
                      author.fields.name || author.fields.image.fields.title!
                    }
                    width={"150px"}
                    height={"150px"}
                    wrapperClassNames="!bottom-0 max-w-[90px] md:max-w-[80px]"
                  />
                </div>
              )}
              <div
                className={classNames(
                  bylineImage ? "max-w-[calc(100%-80px)]" : "",
                )}
              >
                <TeaserDownpull
                  showByline={showByline}
                  authorName={author?.fields.name}
                  excerpt={props.article.fields.excerpt}
                  showbyLineImage={bylineImage}
                />
              </div>
            </div>
          </div>
        </Link>
      </LinkedContent>
    </>
  );
};

export default Horizontal;
